import React from "react";
import Flexbox from "core/Flexbox";
import Heading from "core/Heading";
import { checkoutFormHeader, subscriptionDesc } from "subscriptions/data";
import {
    SubDescContainer,
    SubscriptionCheckoutHeader,
    USDText
} from "subscriptions/styles";

const CheckoutHeader = () => {
    return (
        <Flexbox flexDirection="column">
            <SubscriptionCheckoutHeader>
                <Heading size="xs">{checkoutFormHeader}</Heading>
                <USDText>USD</USDText>
            </SubscriptionCheckoutHeader>
            <SubDescContainer size="md">{subscriptionDesc}</SubDescContainer>
        </Flexbox>
    );
};

export default CheckoutHeader;
